export enum ActionType {
  GET_LANGUAGE_LIST_REQUEST = 'get_language_list_request',
  GET_LANGUAGE_LIST_SUCCESS = 'get_language_list_success',
  GET_LANGUAGE_LIST_ERROR = 'get_language_list_error'
}
